import {Trans, useTranslation} from '@/translations/i18n'
import {AccessDashboardCard} from '../access-dashboard-card/AccessDashboardCard'
import {useGetAccessesDashboard} from '../../queries/useGetAccessesDashboard'
import {useParsedSearchParams} from '@/hooks/useParsedSearchParams'
import {filtersParamToPayload} from '@/utilities/helpers'
import {AccessesTableDashboardEmptyState} from '../accesses-table-dashboard/AcccessesTableDashboardEmptyState'
import {Text} from '@/components/ui/text/Text'
import {AccessesSearchParams} from '../../types'
import {useAccessesCardFilterChecks} from '../../hooks/useAccessesCardFilterChecks'

export const AccessesDashboardNonInPersonAccessesCard = () => {
    const {t} = useTranslation()
    const {searchParams} = useParsedSearchParams(AccessesSearchParams)

    const {isFilteringFor} = useAccessesCardFilterChecks({
        filters: searchParams.filters,
        filterKeys: ['projectCode']
    })

    const {data, isLoading} = useGetAccessesDashboard<'non_in_person_accesses'>({
        payload: {
            filters: filtersParamToPayload(searchParams.filters)?.filters
        },
        params: {
            card: 'non_in_person_accesses',
            startDate: searchParams.startDate,
            endDate: searchParams.endDate
        }
    })

    if (isLoading || !data) {
        return <AccessesTableDashboardEmptyState title={t('accesses:dashboard_absences')} isLoading={isLoading} />
    }

    return (
        <AccessDashboardCard title={t('accesses:dashboard_absences')}>
            <Text size="textSm" palette="neutral" shade="600">
                {isFilteringFor('projectCode') ? (
                    <Trans
                        i18nKey="accesses:dashboard_absences_subtitle"
                        values={{count: data?.nonInPersonAccesses.done, total: data?.nonInPersonAccesses.planned}}
                        components={[
                            <Text render="span" size="textLg" palette="neutral" shade="950" weight="600" />,
                            <Text render="span" size="textLg" palette="neutral" shade="600" weight="500" />
                        ]}
                    />
                ) : (
                    <Text size="textLg" palette="neutral" shade="950" weight="600">
                        {data?.nonInPersonAccesses.done}
                    </Text>
                )}
            </Text>
        </AccessDashboardCard>
    )
}
